import {Stack} from '@primer/react-brand'

import type {AppStoreButton} from '../../../../../schemas/contentful/contentTypes/appStoreButton'
import type {PrimerComponentHero} from '../../../../../schemas/contentful/contentTypes/primerComponentHero'
import {MobileAppStoreLink} from '../AppStoreLinks/MobileAppStoreLinks'

type TrailingComponentProps = {
  components: PrimerComponentHero['fields']['trailingComponent']
}

type TrailingComponentPropTypes = AppStoreButton

function getTrailingComponent(component: TrailingComponentPropTypes) {
  const map: Record<TrailingComponentPropTypes['sys']['contentType']['sys']['id'], React.ElementType> = {
    appStoreButton: MobileAppStoreLink,
  }

  return map[component.sys.contentType.sys.id]
}

export function TrailingComponent({components}: TrailingComponentProps) {
  return (
    <Stack gap="condensed" className="p-0" direction="horizontal">
      {components?.map(component => {
        const Component = getTrailingComponent(component)

        return Component !== undefined ? <Component component={component} key={component.sys.id} /> : null
      })}
    </Stack>
  )
}

try{ TrailingComponent.displayName ||= 'TrailingComponent' } catch {}
try{ Component.displayName ||= 'Component' } catch {}